import React, { Component } from "react"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import Typography from "@material-ui/core/Typography"

class Index extends Component {
  render() {
    // const { classes } = this.props
    return <Typography variant="h2">Index Here</Typography>
  }
}

export default withStyles(styles)(Index)



// WEBPACK FOOTER //
// ./src/pages/Index/index.jsx